export function buildBordersMask(indices, borderMask) {
  const edgesSet = new Set();
  const maxIndex = borderMask ? borderMask.length : 0;

  for (let i = 0; i < indices.length; i += 3) {
    const ind0 = indices[i];
    const ind1 = indices[i + 1];
    const ind2 = indices[i + 2];

    const hash1 = Math.max(ind0, ind1) * maxIndex + Math.min(ind0, ind1);
    const hash2 = Math.max(ind1, ind2) * maxIndex + Math.min(ind1, ind2);
    const hash3 = Math.max(ind2, ind0) * maxIndex + Math.min(ind2, ind0);

    if (edgesSet.has(hash1)) {
      edgesSet.delete(hash1);
    } else {
      edgesSet.add(hash1);
    }

    if (edgesSet.has(hash2)) {
      edgesSet.delete(hash2);
    } else {
      edgesSet.add(hash2);
    }

    if (edgesSet.has(hash3)) {
      edgesSet.delete(hash3);
    } else {
      edgesSet.add(hash3);
    }
  }

  for (const hash of edgesSet) {
    const i1 = Math.floor(hash / maxIndex);
    const i2 = hash % maxIndex;

    borderMask[i1] = 1;
    borderMask[i2] = 1;
  }

  return borderMask;
}